function createFormatErrorMessage(baseUrl, prefix) {
  return function formatErrorMessage2(code, ...args) {
    const url = new URL(baseUrl);
    url.searchParams.set("code", code.toString());
    args.forEach((arg) => url.searchParams.append("args[]", arg));
    return `${prefix} error #${code}; visit ${url} for the full message.`;
  };
}
const formatErrorMessage = createFormatErrorMessage("https://base-ui.com/production-error", "Base UI");
export {
  createFormatErrorMessage,
  formatErrorMessage as default
};
//# sourceMappingURL=formatErrorMessage.js.map
